import React from 'react';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Cell
} from 'recharts';
import StatisticsGlassCard from './StatisticsGlassCard';
import StatisticsDesktopSectionHeader from './StatisticsDesktopSectionHeader';
import { STATS_ICONS } from './statisticsAssets';
import useChartContainerReady from './useChartContainerReady';

export default function StatisticsDesktopNewcomerFunnelCard({
    newcomerFunnelStats,
    isEditMode,
    longPressHandlers,
    theme
}) {
    const { containerRef, isReady } = useChartContainerReady();
    const primaryColor = theme?.primaryHex || '#6366F1';

    const totalNewcomers = newcomerFunnelStats?.[0]?.count || 0;

    const getOpacity = (index) => {
        const opacities = [1, 0.65, 0.35];
        return opacities[index] || 0.35;
    };

    return (
        <StatisticsGlassCard className="h-full p-6 flex flex-col" {...longPressHandlers} isEditMode={isEditMode}>
            <div className="w-full mb-2">
                <StatisticsDesktopSectionHeader
                    iconSrc={STATS_ICONS.fire}
                    title="새가족 정착 트래커"
                    badge={`${totalNewcomers}명`}
                />
            </div>

            <div ref={containerRef} className="relative w-full flex-1">
                {isReady ? (
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart
                            data={newcomerFunnelStats}
                            layout="vertical"
                            margin={{ top: 10, right: 30, left: 20, bottom: 5 }}
                        >
                            <defs>
                                {newcomerFunnelStats.map((_, index) => (
                                    <linearGradient key={`fg-${index}`} id={`funnelGrad-${index}`} x1="0" y1="0" x2="1" y2="0">
                                        <stop offset="0%" stopColor={primaryColor} stopOpacity={getOpacity(index)} />
                                        <stop offset="100%" stopColor={primaryColor} stopOpacity={getOpacity(index) * 0.6} />
                                    </linearGradient>
                                ))}
                            </defs>
                            <CartesianGrid strokeDasharray="3 3" vertical={true} horizontal={false} stroke="#F3F4F6" />
                            <XAxis type="number" hide />
                            <YAxis
                                dataKey="step"
                                type="category"
                                axisLine={false}
                                tickLine={false}
                                tick={{ fill: '#6B7280', fontSize: 11, fontWeight: 'bold' }}
                                width={80}
                            />
                            <Tooltip
                                cursor={{ fill: 'rgba(0,0,0,0.03)' }}
                                contentStyle={{
                                    backgroundColor: 'rgba(255,255,255,0.98)',
                                    border: 'none',
                                    borderRadius: '16px',
                                    boxShadow: '0 12px 48px rgba(0,0,0,0.12)',
                                    padding: '10px 14px',
                                    fontSize: '12px',
                                    fontWeight: 700,
                                }}
                                formatter={(value) => [`${value}명`, '인원']}
                            />
                            <Bar dataKey="count" radius={[0, 8, 8, 0]} barSize={28} animationDuration={1200}>
                                {newcomerFunnelStats.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={`url(#funnelGrad-${index})`} />
                                ))}
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                ) : null}
            </div>
        </StatisticsGlassCard>
    );
}
